import AppExtensionsSDK, { Event, Command } from '@pipedrive/app-extensions-sdk';
import pubsub from 'sweet-pubsub';
import { AmplitudeLogger, EVENTS } from "../utils";
export const useCti = async () => {
    let phoneNumber = null;
    let isLoggedIn = false;
    const defaultSize = { width: 320, height: 460 };
    const cti = await new AppExtensionsSDK()
        .initialize({ size: defaultSize });
    console.log(cti);
    cti.listen(Event.VISIBILITY, async ({ error, data }) => {
        if (error) {
            return;
        }
        const { context, is_visible } = data;
        if (!context) {
            return;
        }
        const { callToNumber, invoker, relatedIds } = context;
        if (!callToNumber) {
            return;
        }
        const { dealId, orgId, personId } = relatedIds;
        phoneNumber = callToNumber;
        if (!is_visible) {
            await cti.execute(Command.SHOW_FLOATING_WINDOW, {
                context,
            });
        }
        if (isLoggedIn) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        isLoggedIn = true;
        if (phoneNumber) {
            setTimeout(() => {
                pubsub.emit('initiate_call', phoneNumber);
            }, 1000);
        }
        AmplitudeLogger.log(EVENTS.LOGIN, { mobile, email, first_name, last_name });
    });
    pubsub.on('number_selected', (number = null) => {
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
        AmplitudeLogger.log(EVENTS.NUMBER_SELECTED, { number });
    });
    pubsub.on('call_ringing', async ({ peer }) => {
        if (peer) {
            await cti.execute(Command.SHOW_FLOATING_WINDOW, {
                context: {
                    peer
                },
            });
        }
        AmplitudeLogger.log(EVENTS.RINGING, { phone: peer });
    });
    pubsub.on('call_started', async ({ direction, peer }) => {
        const callStartTime = Date.now();
        const payload = {
            callStartTime,
            phoneNumber: peer || phoneNumber
        };
        await cti.execute(Command.SET_FOCUS_MODE, true);
        AmplitudeLogger.log(EVENTS.CALL_STARTED, { payload, direction, peer });
    });
    pubsub.on('call_ended', async ({ direction, peer, duration, notes }) => {
        await cti.execute(Command.SET_FOCUS_MODE, false);
        AmplitudeLogger.log(EVENTS.CALL_ENDED, { direction, peer, duration, notes });
    });
    pubsub.on('logout', () => {
        isLoggedIn = false;
        AmplitudeLogger.log(EVENTS.LOGOUT, {});
    });
    pubsub.on('initiate_call', phone => {
        AmplitudeLogger.log(EVENTS.INIT_CALL, { phone });
    });
    return cti;
};
